import ApartmentsAPI from './apartments'
import i18n from '../translations/i18n'

export interface OpenAIResponse {
    result?: string
    error?: string
}

export async function runAIGenerationAndUpdateNotes(
    userId: string,
    apartmentId: string,
    information: any
): Promise<void> {
    try {
        const message = [
            {
                role: 'system',
                content:
                    'Olet tekoälymalli, jonka rooli on toimia kiinteistönvälittäjänä. Kirjoita kattava ja myyvä vuokra-asunnon myynti-ilmoitus. Kirjoita esittelyteksti ilman väliotsikoita. Kuvaile ilmoituksessa asuntoa, sen ominaisuuksia, sijaintia (älä kuitenkaan mainitse kaupunginosaa) sekä lähellä olevia palveluita. Kirjoita suomeksi. Älä kirjoita ilmoitukseen minkäänlaisia ohjeita ja/tai kehoituksia yhteydenottoon liittyen. Älä käytä erikoismerkkejä. Älä käytä sanaa "apukeittiö", käytä vain "keittiö". Älä käytä sanaa "moderni" ellei asunto ole uusi tai vuokranantaja kuvaa sitä itse sellaiseksi. Käytä huonemäärästä pelkästään lyhenteitä kuten yksiö, kaksio, kolmio. Älä ilmoita asunnon kerrosta jos kyseessä on rivitalo, omakotitalo, paritalo tai erillistalo. Oleta, että pyykinpesukone sijaitsee kylpyhuoneessa ellei muuta ole erikseen mainittu. Jos koneelle on paikka mutta konetta ei ole, ilmaise se "paikka pyykinpesukoneelle". Vastauksesi tulee olla enintään 1500 merkkiä pitkä tai 200 sanaa. Varmista, että teksti on kokonainen eikä katkea kesken kaiken. Asunto sijaitsee osoitteessa ' +
                    `${information.streetAddress} ${information.streetNumber}, ${information.postalArea}, ${information.postalCode}.`,
            },
            {
                role: 'user',
                content: `Asunto on ${i18n.t(`apartment.buildingType.${information.buildingType}`)}, joka on ${information.rooms}+${i18n.t(`apartment.kitchen.${information.kitchen}`)}${information.balcony ? `+${i18n.t(`apartment.balcony.${information.balcony}`)}${information.balcony !== 'no' ? ' parveke.' : ''}` : ''} ${information.floor ? `Asunto sijaitsee ${information.floor}${information.floors ? `/${information.floors}` : ''} kerroksessa.` : ''} ${information.dishwasher === 'yes'
                    ? 'Asunnossa on astianpesukone.' : information.dishwasher === 'installable'
                        ? 'Asunnossa on mahdollisuus asentaa astianpesukone.' : ''} ${information.laundryMachine === 'yes'
                            ? 'Asunnossa on pyykinpesukone.' : information.laundryMachine === 'installable'
                                ? 'Asunnossa on mahdollisuus asentaa pyykinpesukone.' : ''} Asunnon ominaisuudet ovat ${[
                                    information.internetIncluded ? 'internet' : '',
                                    information.petsAllowedCheckBoxProperty ? 'lemmikit sallittu' : '',
                                    information.hasSaunaCheckBoxProperty ? 'sauna' : '',
                                    information.hasElevator ? 'hissi' : '',
                                    information.isFurnished ? 'kalustettu' : '',
                                    information.hasBuiltInClosetCheckBoxProperty ? 'vaatehuone' : '',
                                    information.renovatedCheckBoxProperty ? 'remontoitu' : '',
                                    information.waterFeeBasis === 'included' ? 'vesimaksu sisältyy vuokraan' : '',
                                    information.firstRentDiscount50PercentCheckBoxProperty ? 'ensimmäinen vuokra 50% halvempi' : ''
                                ].filter(Boolean).join(', ')}.${(information.renovations || information.damages) ? ` Asunnossa on tehty seuraavat remontit: ${[
                                    information.renovations,
                                    information.damages
                                ].filter(Boolean).join('. ')}.` : ''}`
            },
            {
                role: 'system',
                content: `Tässä vuokranantajan itse kirjoittama teksti, jota tulisi käyttää osana esittelytekstiä. Älä mainitse, että teksti on vuokranantajan kirjoittama, vaan sisällytä se osaksi sinun kirjoittamaa tekstiä mahdollisimman paljon sanasta sanaan: ${information.notes}`
            }
        ]

        const aiResponse: OpenAIResponse = await ApartmentsAPI.callOpenAI(
            message,
            'gpt-4o',
            0.5,
            700
        )

        if (aiResponse && aiResponse.result) {
            const updatedApartmentInformation: any = {
                ...information,
                notes: aiResponse.result
            }

            await ApartmentsAPI.updateApartmentInformation(
                userId,
                apartmentId,
                updatedApartmentInformation
            )
        } else {
            throw new Error('AI generation failed')
        }
    } catch (error) {
        console.error('Error generating AI content and updating notes:', error)
    }
}
